
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memberships/[membershipId]/terms-and-conditions",
      function () {
        return require("private-next-pages/memberships/[membershipId]/terms-and-conditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memberships/[membershipId]/terms-and-conditions"])
      });
    }
  